//sync with back

export enum cloudProviders {
    AWS = 'aws',
    GCP = 'gcp',

    WBCE = 'wbce',
    OVH = 'ovh',
}
